export default {
  title: 'Data i godzina',
  buttons: {
    done: 'Gotowe',
  },
};
